export enum ContentType {
  Article = 235,
  Approved_Exception = 183,
  Branch = 184,
  Issue_Explorer = 222,
  Top_Practices = 161,
  Data_View_Detailed = 129,
  Impact_Appraisal = 156,
  Blog = 226,
  CRITICAL_CAPABILITIES = 148,
  MAGIC_QUADRANT = 106,
  ReportHighlight = 127,
  HYPE_CYCLE = 137,
  INNOVATION_PROFILE = 185,
  PROJECT_DERIVATIVE = 314,
  CIO_INITIATIVE_ACCELERATOR = 315,
  KI_PRIMER = 155,
  DATA_INTERACTIVE = 316,
  MARKET_DEFINITION = 319,
  MARKET_GUIDE = 266,
  Radar_Profile = 322,
  Emerging_Tech_Impact_Radar = 323,
  Impact_Radar = 310,
  Executive_FastStart = 329,
  Pilot = 291,
  MCP_Overview = 333,
  First_Take = 335,
  Analyst_Take = 332
}
